export const applyStyle = {
    pageContainer: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center" as const,
      justifyContent: "center" as const,
      padding: "60px 20px",
      marginTop:"60px",
    },
    pageContainer2: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center" as const,
      justifyContent: "center" as const,
      padding: "0px 20px",
      marginTop:"0px",
      marginBottom: "20px"
    },
    applyContainer: {
      display: "flex",
      justifyContent: "center",
      gap: "20px", 
      flexWrap: "wrap" as const, 
      maxWidth: "1000px",
      width: "100%",
    },
    applyCard: {
      flex: 1,
      maxWidth: "500px", 
      minWidth: "450px",  
      height: "300px", 
      marginBottom: "30px", 
    },
    card: {
      padding: "0px",  
      width: "100%",
      borderRadius: "8px",
      overflow: "hidden",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      height: "100%", 
      display: "flex",
      flexDirection: "column" as const, 
      justifyContent: "center", 
    },
    image: {
      width: "100%", 
      height: "150px", 
      objectFit: "cover" as const, 
      borderRadius: "8px 8px 0 0", 
    },
    heading: {
      color: "black",
      marginBottom: "40px", 
      marginTop: "0px", 
      textAlign: "center" as const, 
    },
    whyUsContainer: {
      maxWidth: "800px",
      textAlign: "left" as const,
      marginBottom: "50px",
      padding: "20px",
      lineHeight: "1.5",
    },
    whyUsHeading: {
      fontSize: "28px",
      fontWeight: "bold" as const,
      marginBottom: "20px",
    },
    whyUsList: {
      listStyleType: "disc" as const,
      paddingLeft: "20px",
      marginBottom: "20px",
    },
    cardTitle: {
      color: "#007bff",
      fontSize: "20px",
      fontWeight: "bold" as const,
      marginBottom: "10px",
    },
    cardText: {
      flexGrow: 1, 
      textAlign: "center" as const,
      marginRight: "10px",
      marginLeft: "10px"
    },
    cardButton: {
      marginTop: "50px",
    },
  };
  